import React from 'react'
import data from '../data'
import { ChartCard } from './chart-card';
import {
  DonutChartLegend as Legend,
  DonutChart,
  DonutChartBig,
  HorizontalBarChart,
} from '../../../components';
import colors from '../../../utils/colors';

const COLORS = [colors.green, '#52BAE2', '#FF5448', '#7171EF', '#FFC020', '#753A00'];

const {
  organization,
  organizationFiltered,
  approach,
  approachFiltered,
  issues,
  issuesFiltered,
  location,
  locationFiltered
} = data

const Statistics = ({filtered}) => {
  const organizationData = filtered ? organizationFiltered : organization
  const approachData = filtered ? approachFiltered : approach
  const issuesData = filtered ? issuesFiltered : issues
  const locationData = filtered ? locationFiltered : location

  return (
    <React.Fragment>
      <div className="flex flex-wrap -mx-4">
        <div className="w-full lg:w-1/2 px-4">
          <ChartCard
            title="Organization"
            className="mb-5 lg:mb-8"
            legend={<Legend data={organizationData.data} total={organizationData.total} colors={COLORS} />}
            chart={<DonutChartBig data={organizationData.data} total={organizationData.total} colors={COLORS} />}
          />
          <ChartCard
            title="Approach"
            className="mb-5 lg:mb-8"
            legend={<Legend data={approachData.data} total={approachData.total} colors={COLORS} />}
            chart={<DonutChart data={approachData.data} total={approachData.total} colors={COLORS} />}
          />
          <ChartCard
            title="Issues"
            className="mb-5 lg:mb-8"
            legend={<Legend data={issuesData.data} total={issuesData.total} colors={COLORS} />}
            chart={<DonutChart data={issuesData.data} total={issuesData.total} colors={COLORS} />}
          />
        </div>
        <div className="w-full lg:w-1/2 px-4">
          <HorizontalBarChart data={locationData}/>
        </div>
      </div>
    </React.Fragment>
  )
}

export { Statistics }